import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "subtitle" }
const _hoisted_3 = { class: "field mb-5" }
const _hoisted_4 = { class: "control has-icons-left" }
const _hoisted_5 = { class: "columns is-multiline" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "card-header" }
const _hoisted_8 = { class: "card-header-title" }
const _hoisted_9 = { class: "card-content" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = {
  key: 0,
  class: "has-text-centered py-6"
}
const _hoisted_12 = { class: "is-size-5 has-text-grey" }
const _hoisted_13 = { class: "has-text-grey-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_breadcrumb_item = _resolveComponent("b-breadcrumb-item")!
  const _component_b_breadcrumb = _resolveComponent("b-breadcrumb")!
  const _component_b_input = _resolveComponent("b-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_breadcrumb, {
      size: "is-large",
      separator: "has-succeeds-separator",
      "aria-label": "breadcrumbs"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_breadcrumb_item, {
          tag: "router-link",
          to: "/projects"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('projects.title')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_b_breadcrumb_item, { active: "" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('projects.galleryTitle')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('projects.chooseType')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_b_input, {
            modelValue: _ctx.searchQuery,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            placeholder: _ctx.$t('projects.searchPlaceholder'),
            type: "search",
            icon: "magnify",
            "icon-clickable": "",
            onIconClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchQuery = ''))
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTemplates, (template) => {
          return (_openBlock(), _createElementBlock("div", {
            key: template.id,
            class: "column is-one-third"
          }, [
            _createElementVNode("div", {
              class: "card is-clickable",
              onClick: ($event: any) => (_ctx.goAdd(template.id))
            }, [
              _createElementVNode("header", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(template.title), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(template.description), 1)
              ])
            ], 8, _hoisted_6)
          ]))
        }), 128))
      ]),
      (_ctx.filteredTemplates.length === 0 && _ctx.searchQuery)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('projects.noResults')), 1),
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('projects.tryDifferentSearch')), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}